<template>
  <div class="analytic-report">
    <SpinnerLoading v-if="isLoading" class="loader_center" color="blue" />

    <template v-else-if="cameraInfo && cameraInfo.isAvailableArchive()">
      <div class="analytic-report__settings">
        <SmartSelect
          v-model="timeBucket"
          :options="settingsTimeBucket"
          caption="Отчет"
          width="fill"
          class="analytic-report__settings-control analytic-report__settings-control_small"
          @input="loadReportTimeBucket"
        />
        <SmartInputDate
          v-model="archiveFrom"
          :config-flat-pickr="{minDate: minEventArchiveFrom, maxDate: maxEventArchiveTo}"
          caption="Дата начала"
          class="analytic-report__settings-control analytic-report__settings-control_small"
        />
        <SmartInputDate
          v-model="archiveTo"
          :config-flat-pickr="{minDate: minEventArchiveFrom, maxDate: maxEventArchiveTo}"
          caption="Дата конца"
          class="analytic-report__settings-control analytic-report__settings-control_small"
        />
        <CamsButton
          class="analytic-report__settings-control"
          priority="primary"
          type="button"
          @click="downloadTableAsCSV()"
        >
          Скачать отчет
        </CamsButton>
      </div>
      <div class="analytic-report__table cams-table-wrapper">
        <SpinnerLoading v-if="isLoadingReport" class="loader_center" color="blue" />
        <table v-if="timeBucket!=='defaultReport'" class="cams-table">
          <tr>
            <th class="cams-table__cell cams-table__cell_fixed-width" />
            <th class="cams-table__cell" style="width: 400px">
              Дата
            </th>

            <th class="cams-table__cell">
              Вошло
            </th>
            <th class="cams-table__cell">
              Вышло
            </th>
          </tr>
          <template v-for="message in messages.results">
            <tr :key="message.id" :class="{'warning warning-bg': message.alarm}">
              <td class="cams-table__cell cams-table__cell_fixed-width" />
              <td v-if="timeBucket!=='1'" class="cams-table__cell">
                {{ message.start | localDateTime }}  - {{ message.end | localDateTime }}
              </td>
              <td v-if="timeBucket==='1'" class="cams-table__cell">
                {{ message.start | localDateTime }}  - {{ message.end | localDateTime }}
              </td>
              <td class="cams-table__cell">
                {{ message.in_count }}
              </td>
              <td class="cams-table__cell">
                {{ message.out_count }}
              </td>
            </tr>
          </template>
        </table>
        <table v-else-if="messages" class="cams-table">
          <tr>
            <th class="cams-table__cell cams-table__cell_fixed-width" />
            <th class="cams-table__cell">
              Текст
            </th>
            <th class="cams-table__cell">
              Дата
            </th>
          </tr>
          <template v-for="message in messages">
            <tr :key="message.id" :class="{'warning warning-bg': message.alarm}">
              <td class="cams-table__cell cams-table__cell_fixed-width">
                <div class="analytic-report__event-actions">
                  <CamsButton
                    v-show="message.date >= minVideoArchiveFrom"
                    icon-type="only"
                    title="Видео события"
                    type="button"
                    @click="playEventStart(message, cameraInfo)"
                  >
                    <svg>
                      <use xlink:href="#icon-video-preview" />
                    </svg>
                  </CamsButton>
                  <CamsButton
                    v-show="message.date >= minVideoArchiveFrom"
                    icon-type="only"
                    title="Скачать видео события"
                    type="button"
                    @click="downloadEventVideo(message, cameraInfo)"
                  >
                    <svg>
                      <use xlink:href="../../../assets/img/icons.svg#cloud-archive" />
                    </svg>
                  </CamsButton>
                </div>
              </td>
              <td class="cams-table__cell">
                {{ message.text==="in"? "Вход" : "Выход" }}
              </td>
              <td class="cams-table__cell">
                {{ message.date | localDateTime }}
              </td>
            </tr>
          </template>
        </table>

        <template v-else>
          <p>События на данном промежутке времени отсутствуют.</p>
        </template>
      </div>
    </template>

    <template v-else>
      <p>Ошибка: невозможно получить доступ к архиву</p>
    </template>

    <iframe :src="downloadUrl" frameborder="0" height="1" width="1" />
  </div>
</template>

<script>
import {analyticReportMixin} from "@/components/oneScreen/reports/mixins.js";
import {downloadCSV} from "@/utils/helpers.js";
import {
  ACTION_LOAD_PEOPLE_COUNT_REPORT,
  ACTION_LOAD_PEOPLE_COUNT_REPORT_COUNT_BUCKET, TIME_RANGE_REPORT
} from "@/store/analytics/peopleCount/index.js";

/**
 * Отчет по подсчету посетителей.
 */
export default {
  name: "PeopleReportScreen",
  mixins: [
    analyticReportMixin,
  ],
  data() {
    return {
      archiveFrom: null,
      archiveTo: null,
      searchText: null,
      settingsTimeBucket: TIME_RANGE_REPORT,
      timeBucket: "defaultReport",
    };
  },
  computed: {
    /**
     * @return {Date} Корректное представление archiveFrom в сравнении с archiveTo.
     */
    clearArchiveFrom() {
      return this.archiveFrom && this.archiveTo ? new Date(Math.min(this.archiveFrom.getTime(), this.archiveTo.getTime())) : null;
    },
    /**
     * @return {Date} Корректное представление archiveTo в сравнении с archiveFrom.
     */
    clearArchiveTo() {
      return this.archiveFrom && this.archiveTo ? new Date(Math.max(this.archiveFrom.getTime(), this.archiveTo.getTime())) : null;
    },
  },
  watch: {
    // Отслеживание значений фильтров для автоматического обновления отчета.
    archiveFrom() {
      this.debouncedLoadReportBucket();
    },
    archiveTo() {
      this.debouncedLoadReportBucket();
    },
    searchText() {
      this.debouncedLoadReportBucket();

    },
  },
  /**
   * Регистрируется отложенная загрузка отчета для случаев быстрого изменения фильтров.
   */
  created() {
    this.debouncedLoadReportBucket = _.debounce(this.loadReportTimeBucket, 350);

  },
  methods: {

    /**
     * Сброс фильтров в начальное состояние.
     * Фильтры по умолчанию по датам за последний час.
     */
    resetFilters() {
      const archiveTo = new Date(),
            archiveFrom = new Date(archiveTo.getTime());
      archiveFrom.setHours(archiveTo.getHours() - 1);
      this.archiveFrom = archiveFrom;
      this.archiveTo = archiveTo;
      this.searchText = "";
    },
    /**
     * Загрузка отчета по заданным параметрам.Загрузится либо общий отчет либо агрегированный отчет в зависимости от timeBucket
     */
    async loadReportTimeBucket() {
      if (!this.clearArchiveFrom || !this.clearArchiveTo) {
        return;
      }
      if (this.timeBucket==='defaultReport'){
        this.messages = [];
        this.messages = await this.$store.dispatch(`analytics/peopleCount/${ACTION_LOAD_PEOPLE_COUNT_REPORT}`, {
          cameraNumber: this.cameraInfo.number,
          archiveFrom: this.clearArchiveFrom,
          archiveTo: this.clearArchiveTo,
          query: this.searchText,
        });
      }  else
      {
        this.messages = [];
        this.messages = await this.$store.dispatch(`analytics/peopleCount/${ACTION_LOAD_PEOPLE_COUNT_REPORT_COUNT_BUCKET}`, {
          cameraNumber: this.cameraInfo.number,
          archiveFrom: this.clearArchiveFrom,
          archiveTo: this.clearArchiveTo,
          timeBucket: this.timeBucket,
        });
      }
    },
    /**
     * Выгрузка данных таблицы в виде CSV.
     */
    downloadTableAsCSV() {
      const filename = `Отчет ${this.cameraInfo.title}.csv`;
      let csvText = "";
      let headers = [
        "Дата",
        "Вошло посетителей",
        "Вышло посетителей",
      ];
      if(this.timeBucket==='defaultReport') {
        let headersDefault = [
          "Текст",
          "Дата",
        ];
        csvText = `${headersDefault.join(',')}\r\n`;
        this.messages.forEach((message) => {
          csvText += `${message.text},${this.$options.filters.localDateTime(message.date)}\r\n`;
        });} else{
        csvText = `${headers.join(',')}\r\n`;
        this.messages.results.forEach((message) => {
          csvText += `${this.$options.filters.localDateTime(message.date)},${message.in_count},${message.out_count}\r\n`;
        });}
      downloadCSV(filename, csvText);
    },
  },
};
</script>

<style lang="scss">
@import "./analytic-report.scss";
</style>
